import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const Heading = styled.h1<{ $flush?: boolean }>`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.tight};
  color: ${semantic.text.primary};
  text-align: left;
  margin: 0 0 ${({ $flush }) => ($flush ? '0' : space['space-800'])};
  max-width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
    max-width: ${({ $flush }) => ($flush ? '100%' : '75%')};
  }
`;

export const Subtitle = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;
